import Reveal from "@/components/base/Reveal";
import { digestData } from "@/mocks/homeData";

export default function DigestSection() {
  return (
    <section id="digest" className="w-full border-y border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-center lg:gap-14">
          <Reveal className="lg:col-span-5">
            <span className="font-label text-xs tracking-[0.2em] text-secondary-600">QUICK DIGEST</span>
            <h3 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              课代表梳理
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              没时间读完整条时间线？先看这份要点小结。它只讲结论和转折，不掺情绪，五分钟就能跟上进度。
            </p>

            <div className="mt-7 h-52 w-full overflow-hidden rounded-lg border border-background-200/80 sm:h-64">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20a%20handwritten%20summary%20card%2C%20two%20highlight%20pens%20and%20a%20small%20watermelon%20slice%20neatly%20arranged%20on%20a%20warm%20cream%20paper%20background%2C%20soft%20diffused%20daylight%2C%20muted%20amber%20and%20deep%20teal%20accents%2C%20clean%20minimal%20composition%2C%20high%20detail%20photography&width=1000&height=1000&seq=gcg-digest-01&orientation=squarish"
                alt="超碰吃瓜课代表梳理卡片"
                title="超碰吃瓜课代表梳理"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </Reveal>

          <div className="lg:col-span-7">
            <div className="rounded-lg border border-background-200/80 bg-background-50 p-6 md:p-8">
              <ol className="space-y-5">
                {digestData.map((point, index) => (
                  <Reveal key={point.no} delay={index * 70}>
                    <li className="flex gap-4">
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 font-label text-base text-secondary-800">
                        {point.no}
                      </span>
                      <div>
                        <h4 className="font-heading text-base font-bold text-foreground-950">{point.title}</h4>
                        <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
                      </div>
                    </li>
                  </Reveal>
                ))}
              </ol>

              <div className="mt-7 flex flex-wrap items-center gap-3 border-t border-background-200 pt-6">
                <span className="inline-flex items-center gap-2 text-xs text-foreground-500">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-refresh-line text-sm"></i>
                  </span>
                  小结随节点更新同步刷新
                </span>
                <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                  共 5 个关键转折
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}